import moment from "moment";
import { ORDER_STATUS } from "../../../Shared/utils/constants";
import { dateFilters } from "../../constants";
const sortOrders = (orders, dateFilter) => {
    // If the orders include "upcoming" orders sort them chronologically by the date or week starting on date
    if (dateFilter === dateFilters.upcoming) {
        return orders === null || orders === void 0 ? void 0 : orders.sort((a, b) => {
            const aDate = a.order.OrderIsUpcoming ? moment(a.order.ForWeekStartingOn) : moment(a.orderInfo.order_date);
            const bDate = b.order.OrderIsUpcoming ? moment(b.order.ForWeekStartingOn) : moment(b.orderInfo.order_date);
            if (aDate.isBefore(bDate)) {
                return -1;
            }
            else if (aDate.isAfter(bDate)) {
                return 1;
            }
            else {
                return 0;
            }
        });
    }
    // otherwise, just return the orders
    else
        return orders;
};
export const processOrders = (orders, dateFilter) => {
    if (!orders) {
        return [];
    }
    if (dateFilter !== dateFilters.upcoming && orders) {
        return orders.filter((o) => { var _a; return ((_a = o.order) === null || _a === void 0 ? void 0 : _a.OrderStatus) !== ORDER_STATUS.FUTURE; });
    }
    return sortOrders(orders, dateFilter);
};
